export const eligibilityFormMetadata = (customers: string[] = []) => ({
  schema: {
    type: 'object',
    properties: {
      firstRow: {
        name: 'firstRow',
        type: 'array',
        inline: true,
        spaceBetweenFields: 16,
        items: [
          {
            name: 'company',
            type: 'string',
            title: 'Company',
            placeholder: 'Acme Inc.',
            multiSelect: false,
            forceMatch: true,
            options: [...customers],
            validation: {
              isRequired: true,
            },
          },
          {
            name: 'dob',
            type: 'string',
            title: 'Date of Birth',
            placeholder: 'MM/DD/YYYY',
            validation: {
              isRequired: true,
              isValidPastDate: true,
            },
          },
        ],
      },
      secondRow: {
        name: 'secondRow',
        type: 'array',
        inline: true,
        spaceBetweenFields: 16,
        items: [
          {
            name: 'firstName',
            type: 'string',
            title: 'First name',
            placeholder: 'Johnny',
            validation: {
              isRequired: true,
            },
          },
          {
            name: 'lastName',
            type: 'string',
            title: 'Last name',
            placeholder: 'Appleseed',
            validation: {
              isRequired: true,
            },
          },
        ],
      },
      // Add dependent question row
      dependentRow: {
        name: 'dependentRow',
        type: 'boolean',
        title: 'Is the patient a dependent?',
        // this is some buggy behavior with the radio button widget with type = boolean the return is 0/1
        // with type = integer the return is true/false the default is 1/0 but statically defining 1/0 for sanity
        enum: [1, 0],
        enumNames: ['Yes', 'No'],
        validation: {
          isRequired: true,
        },
        style: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
      // Add a header row with the eligibility information
      headerRow: {
        name: 'headerRow',
        items: [
          {
            name: 'headerRow',
            content: 'Eligible Member Information',
            condition: {
              parentField: 'dependentRow',
              parentValue: 1,
              noRender: true,
            },
            style: {
              marginTop: 24,
              marginBottom: 16,
              fontWeight: 'bold',
              fontSize: 18,
              color: '#333',
            },
          },
        ],
      },
      thirdRow: {
        name: 'thirdRow',
        type: 'array',
        inline: true,
        spaceBetweenFields: 16,
        items: [
          {
            name: 'eligible_member_first_name',
            type: 'string',
            title: 'Eligible Member First name',
            placeholder: 'Johnny',
            condition: {
              parentField: 'dependentRow',
              parentValue: 1,
              noRender: true,
            },
            validation: {
              isRequired: true,
            },
          },
          {
            name: 'eligible_member_last_name',
            type: 'string',
            title: 'Eligible Member Last name',
            placeholder: 'Appleseed',
            condition: {
              parentField: 'dependentRow',
              parentValue: 1,
              noRender: true,
            },
            validation: {
              isRequired: true,
            },
          },
        ],
      },
      fourthRow: {
        name: 'fourthRow',
        type: 'array',
        inline: true,
        spaceBetweenFields: 16,
        items: [
          {
            name: 'eligible_member_dob',
            type: 'string',
            title: 'Eligible Member Date of Birth',
            placeholder: 'MM/DD/YYYY',
            condition: {
              parentField: 'dependentRow',
              parentValue: 1,
              noRender: true,
            },
            validation: {
              isValidPastDate: true,
              isRequired: true,
            },
          },
        ],
      },
    },
  },
  uiSchema: {
    'ui:order': ['firstRow', 'secondRow', 'dependentRow', 'headerRow', 'thirdRow', 'fourthRow'],
    firstRow: {
      items: [
        {
          'ui:widget': 'typeAhead',
          'ui:options': {
            baseInputStyle: {
              marginBottom: 24,
            },
            inputContainerStyle: {
              borderRadius: 8,
            },
          },
        },
        {
          'ui:widget': 'mask',
          'ui:options': {
            mask: '11/11/1111',
            baseInputStyle: {
              marginBottom: 24,
            },
            style: {
              borderRadius: 8,
            },
          },
        },
      ],
    },
    secondRow: {
      items: [
        {
          'ui:options': {
            baseInputStyle: {
              marginBottom: 24,
            },
            selectFieldStyle: {
              borderRadius: 8,
            },
            inputContainerStyle: {
              borderRadius: 8,
            },
          },
        },
      ],
    },
    dependentRow: {
      'ui:widget': 'radio',
      'ui:options': {
        inline: true,
      },
    },
    headerRow: {
      items: [
        {
          'ui:widget': 'header',
          'ui:options': {
            level: 2,
            style: {
              marginTop: 16,
              marginBottom: 16,
              fontWeight: 'bold',
              color: '#333',
            },
          },
        },
      ],
    },
    thirdRow: {
      items: [
        {
          'ui:options': {
            baseInputStyle: {
              marginBottom: 24,
            },
            selectFieldStyle: {
              borderRadius: 8,
            },
            inputContainerStyle: {
              borderRadius: 8,
            },
          },
        },
      ],
    },
    fourthRow: {
      items: [
        {
          'ui:widget': 'mask',
          'ui:options': {
            mask: '11/11/1111',
            baseInputStyle: {
              marginBottom: 24,
            },
            style: {
              borderRadius: 8,
            },
          },
        },
      ],
    },
  },
})
